<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card
        [advanceButton]="true"
        (outputButtonAdvance)="callFunction($event)"
        [advancedButtons]="specialButtons"
        [cardOptionBtnValue]="'menu.credit-invoice.view'|translate"
        [title]="'global.overview'|translate">
        <app-grid [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>
